import styled from '@emotion/styled';
import { isDJ } from 'utils';

export const WidthContainer = styled.div`
  margin: auto;
  max-width: ${props => props.theme.maxWidth || (isDJ() ? '1240px' : '1220px')};
  padding: 0 10px;
`;
